import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import { checkSession } from "@/lib/auth-client";

export const Route = createFileRoute("/_auth")({
  component: Outlet,
  beforeLoad: async ({ location }) => {
    const check = await checkSession();
    // come back here after signing in (e.g. a Plane task link that went through /plane)
    if (check.state === "signed-out") throw redirect({ to: "/login", search: { next: location.href } });
    if (check.state === "unavailable") {
      // still signed in as far as we know: show the error page (with Reload), not the login form
      throw new Error(`Fieldwork couldn't confirm your session just now (${check.message}). You're still signed in; reload in a moment.`);
    }
    return { session: check.data };
  },
});
